import { useParams } from 'react-router-dom'

import { UserAdminMatchParams } from 'src/models/routeParams'
import { useUser } from 'src/shared/hooks/users'
import LoadingScreen from 'src/shared/views/LoadingScreen'
import UserInfoView from '../views/UserInfo'

const UserInfo = () => {
  const { id: userId } = useParams<UserAdminMatchParams>()

  const { data, isLoading, error } = useUser(userId)

  if (error) return <p>There was an error fetching this user</p>
  if (isLoading || !data) return <LoadingScreen />

  return <UserInfoView user={data} userId={userId} />
}

export default UserInfo
